import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';

import { Observable, Subscription, combineLatest, filter, take, tap } from 'rxjs';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/auth/services/auth.service';
import { UserService } from 'src/app/auth/services/user.service';
import { StudentRoleSettings, UserLevelEnum } from 'src/app/auth/models/UserData';
import { MenuItem } from 'src/app/shared/framework/navigation/models/MenuItem';
import { Company } from 'src/app/shared/personnel-files/models/Company';
import { CompanyService } from 'src/app/shared/personnel-files/services/company.service';
import { NavigationService } from 'src/app/shared/framework/navigation/services/navigation.service';
import { CompanyStylingSettingsService } from 'src/app/modules/framework/settings/services/company-styling-settings.service';
import { Widget } from 'src/app/modules/framework/home-pages/models/Widget';
import { HomepageService } from 'src/app/modules/framework/home-pages/employee-home-page/services/homepage.service';

@Component({
  selector: 'app-sidenavbar',
  templateUrl: './sidenavbar.component.html',
  styleUrls: ['./sidenavbar.component.scss']
})
export class SidenavbarComponent implements OnInit, OnDestroy {

  @ViewChild('modalcontent') modalcontent: any;

  public home: MenuItem;
  public homeActive: boolean = true;
  public level: UserLevelEnum;
  public visibleMenu: SideNavMenuItem[] = [];
  public companies: Company[] = [];

  public roleLabel = '';
  public roles$: Observable<StudentRoleSettings>;
  public Roles = UserLevelEnum;

  public syncWithDefaultNavigation = true;

  public widgetTasks: Widget;
  public widgetRecruitment: Widget;
  public widgetGoals: Widget;
  public widgetDevelopment: Widget;
  public widgetCertificates: Widget;
  public widgetSkills: Widget;
  public widgetConversations: Widget;
  public widgetsLoaded = false;

  public menusWithIconsPerRole: SideNavMenuWrapper[] = [
    {
      role: UserLevelEnum.CorporateHr,
      menus: [
        {
          id: 415, // Organisatie
          icon: 'fas fa-id-card',
          menu: null,
          subMenus: [
            {
              id: 416, // Ondernemingen
              icon: 'fas fa-city',
              menu: null,
              default: true,
            },
            {
              id: 697, // Afdelingen
              icon: 'fas fa-building',
              menu: null,
            },
            {
              id: 418, // OT zoeken
              icon: 'fas fa-address-book',
              menu: null,
            },
            {
              id: 700, // Functies
              icon: 'fas fa-id-card',
              menu: null,
            },
          ]
        },
        {
          id: 696, // Personeelsdossier
          icon: 'fas fa-user-friends',
          menu: null,
          subMenus: [
            {
              id: 417, // Medewerkers
              icon: 'fas fa-user-friends',
              menu: null,
              default: true,
            },
            {
              id: 1002, // Groepen
              icon: 'fas fa-users-cog',
              menu: null,
            },
            {
              id: 477, // Bibliotheekcatalogus
              icon: 'fas fa-file-image',
              menu: null,
            },
            {
              id: 507, // Medewerkersrapport
              icon: 'fas fa-file-excel',
              menu: null,
              default: true,
            },
          ]
        },
        {
          id: 423, // Projecten & Rollen
          icon: 'fas fa-user-tag',
          menu: null,
          subMenus: [
            {
              id: 425, // Projecten
              icon: 'fas fa-project-diagram',
              menu: null,
              default: true,
            },
            {
              id: 426, // Rollen
              icon: 'fas fa-user-tag',
              menu: null,
            },
            {
              id: 424, // Klanten
              icon: 'fas fa-users',
              menu: null,
            },
            {
              id: 427, // Zoekmotor
              icon: 'fas fa-search',
              menu: null,
            }
          ]
        },
        {
          id: 707, // Job & Rolvereisten
          icon: 'fas fa-certificate',
          menu: null,
          subMenus: [
            {
              id: 405, // Dashboard kwalificaties
              icon: 'fas fa-tachometer-alt',
              menu: null,
              default: true,
            },
            {
              id: 753, // Dashboard skills
              icon: 'fas fa-chart-line',
              menu: null,
            },
            {
              id: 467, // Overzicht kwalificaties
              icon: 'fas fa-list',
              menu: null,
            },
            {
              id: 464, // Kwalificaties
              icon: 'fas fa-certificate',
              menu: null,
            },
            {
              id: 434, // Competentiecatalogus
              icon: 'fas fa-asterisk',
              menu: null,
            },
            {
              id: 437, // Vaardighedencatalogus
              icon: 'fas fa-book',
              menu: null,
            },
            {
              id: 504, // Rapporten
              icon: 'fas fa-file-excel',
              menu: null,
            },
          ]
        },
        {
          id: 452, // R&S
          icon: 'fas fa-briefcase',
          menu: null,
          subMenus: [
            // {
            //   id: 402, // Boordtabel
            //   icon: 'fas fa-tachometer-alt',
            //   menu: null,
            // },
            {
              id: 453, // Vacatures
              icon: 'fas fa-briefcase',
              menu: null,
              default: true,
            },
            {
              id: 454, // Kandidaten
              icon: 'fas fa-user-tie',
              menu: null,
            },
            {
              id: 639, // Vacaturetemplates
              icon: 'fas fa-tools',
              menu: null,
            },
            {
              id: 640, // Sollicitatieflowtemplates
              icon: 'fas fa-filter',
              menu: null,
            },
          ]
        },
        {
          id: 720, // LMS
          icon: 'fas fa-graduation-cap',
          menu: null,
          subMenus: [
            {
              id: 993, // FLA
              icon: 'fas fa-tachometer-alt',
              menu: null,
            },
            {
              id: 684, // Leerpaden
              icon: 'fas fa-tasks',
              menu: null,
            },
            {
              id: 480, // Opleidingsplanning
              icon: 'fas fa-calendar-alt',
              menu: null,
              default: true,
            },
            {
              id: 481, // Catalogus
              icon: 'fas fa-graduation-cap',
              menu: null,
            },
            {
              id: 485, // Aanvragen
              icon: 'fas fa-hourglass',
              menu: null,
            },
            {
              id: 723, // Rapporten
              icon: 'fas fa-file-excel',
              menu: null,
            },
          ]
        },
        {
          id: 734, // Prestatiemanagement
          icon: 'fas fa-comments',
          menu: null,
          subMenus: [
            {
              id: 404, // Boordtabellen
              icon: 'fas fa-tachometer-alt',
              menu: null,
            },
            {
              id: 748, // Formele gesprekken
              icon: 'fas fa-calendar-alt',
              menu: null,
            },
            {
              id: 677, // Visuele weergave
              icon: 'fas fa-sliders-h fa-rotate-90',
              menu: null,
            },
            {
              id: 749, // Informele gesprekken
              icon: 'fas fa-comments',
              menu: null,
            },
            {
              id: 750, // Ad hoc gesprekken
              icon: 'fas fa-comment',
              menu: null,
            },
            {
              id: 738, // Rapporten
              icon: 'fas fa-file-excel',
              menu: null,
            },
            {
              id: 1025, // Overzicht gesprekken (nieuwe gesprekkenmodule)
              icon: 'fas fa-comments',
              menu: null,
              default: true,
            },
            {
              id: 1009, // Overzicht gesprekstemplates (nieuwe gesprekkenmodule)
              icon: 'fas fa-tools',
              menu: null,
            },
            {
              id: 1032, // Planning (nieuwe gesprekkenmodule)
              icon: 'fas fa-calendar-alt',
              menu: null,
            },
            {
              id: 1012, // Overzicht gespreksintervallen (nieuwe gesprekkenmodule)
              icon: 'fas fa-sign-in-alt',
              menu: null,
            },
          ]
        },
        {
          id: 525, // Instellingen
          icon: 'fas fa-cog',
          menu: null,
          subMenus: [
            {
              id: 539, // Localhrs
              icon: 'fas fa-user-lock',
              menu: null,
            },
            {
              id: 1034, // Flowgenerator
              icon: 'fas fa-bezier-curve',
              menu: null,
              default: true,
            },
            {
              id: 545, // E-mailflow
              icon: 'fas fa-mail-bulk',
              menu: null,
            },
          ]
        }
      ]
    },
    {
      role: UserLevelEnum.Employee, //Leidinggevende
      manager: true,
      delegate: false,
      menus: [
        {
          id: 224,
          icon: 'fas fa-envelope',
          menu: null
        },
        {
          id: 225, // Digitaal personeelsdossier: wordt momenteel niet getoond
          icon: 'fas fa-id-card',
          menu: null,
          subMenus: [
            {
              id: 225, // Teamleden
              icon: 'fas fa-user-friends',
              menu: null,
              default: true,
            }
          ]
        },
        {
          id: 253, // Bibliotheekcatalogus
          icon: 'fas fa-file-image',
          menu: null,
        },
        {
          id: 905, // Job & Rolvereisten
          icon: 'fas fa-certificate',
          menu: null,
          subMenus: [
            {
              id: 907, // Qualification dashboard
              icon: 'fas fa-tachometer-alt',
              menu: null,
              default: true,
            },
            {
              id: 234, // Kwalificatie overzicht
              icon: 'fas fa-certificate',
              menu: null,
            },
            {
              id: 908, // Skill dashboard
              icon: 'fas fa-chart-line',
              menu: null,
            },
          ]
        },
        {
          id: 1085, // R&S
          icon: 'fas fa-briefcase',
          menu: null,
        },
        {
          id: 909, // LMS
          icon: 'fas fa-graduation-cap',
          menu: null,
          subMenus: [
            {
              id: 997, // FLA
              icon: 'fas fa-tachometer-alt',
              menu: null,
            },
            {
              id: 911, // Leerpaden
              icon: 'fas fa-tasks',
              menu: null,
            },
            {
              id: 969, // Rapporten
              icon: 'fas fa-file-excel',
              menu: null,
            },
            {
              id: 242, // Opleidingsplanning
              icon: 'fas fa-calendar-alt',
              menu: null,
            },
            {
              id: 244, // Catalogus
              icon: 'fas fa-graduation-cap',
              menu: null,
            },
            {
              id: 913, // Aanvragen
              icon: 'fas fa-hourglass',
              menu: null,
              default: true,
            }
          ]
        },
        {
          id: 917, // Prestatiemanagement
          icon: 'fas fa-comments',
          menu: null,
          subMenus: [
            {
              id: 918, // Boordtabellen
              icon: 'fas fa-tachometer-alt',
              menu: null,
            },
            {
              id: 920, // Formele gesprekken
              icon: 'fas fa-calendar-alt',
              menu: null,
            },
            {
              id: 237, // Visuele weergave
              icon: 'fas fa-sliders-h fa-rotate-90',
              menu: null,
            },
            {
              id: 239, // Informele gesprekken
              icon: 'fas fa-comments',
              menu: null,
            },
            {
              id: 240, // Ad hoc gesprekken
              icon: 'fas fa-comment',
              menu: null,
            },
            {
              id: 1023, // Overzicht gesprekken (nieuwe gesprekkenmodule)
              icon: 'fas fa-comments',
              menu: null,
              default: true,
            },
          ]
        }
      ]
    },
    {
      role: UserLevelEnum.Employee, //Delegatie
      manager: true,
      delegate: true,
      menus: [
        {
          id: 299,
          icon: 'fas fa-envelope',
          menu: null
        },
        {
          id: 302, // Digitaal personeelsdossier: wordt momenteel niet getoond
          icon: 'fas fa-id-card',
          menu: null,
          subMenus: [
            {
              id: 302, // Teamleden
              icon: 'fas fa-user-friends',
              menu: null,
              default: true,
            }
          ]
        },
        {
          id: 951, // Bibliotheekcatalogus
          icon: 'fas fa-file-image',
          menu: null,
        },
        {
          id: 929, // Job & Rolvereisten
          icon: 'fas fa-certificate',
          menu: null,
          subMenus: [
            {
              id: 931, // Qualification dashboard
              icon: 'fas fa-tachometer-alt',
              menu: null,
              default: true,
            },
            {
              id: 276, // Kwalificatie overzicht
              icon: 'fas fa-certificate',
              menu: null,
            },
            {
              id: 947, // Skill dashboard
              icon: 'fas fa-chart-line',
              menu: null,
            },
          ]
        },
        {
          id: 996, // LMS
          icon: 'fas fa-graduation-cap',
          menu: null,
          subMenus: [
            {
              id: 1000, // FLA
              icon: 'fas fa-tachometer-alt',
              menu: null,
            },
            {
              id: 934, // Leerpaden
              icon: 'fas fa-tasks',
              menu: null,
            },
            {
              id: 973, // Rapporten
              icon: 'fas fa-file-excel',
              menu: null,
            },
            {
              id: 269, // Opleidingsplanning
              icon: 'fas fa-calendar-alt',
              menu: null,
            },
            {
              id: 272, // Catalogus
              icon: 'fas fa-graduation-cap',
              menu: null,
            },
            {
              id: 936, // Aanvragen
              icon: 'fas fa-hourglass',
              menu: null,
              default: true,
            }
          ]
        },
        {
          id: 952, // Prestatiemanagement
          icon: 'fas fa-comments',
          menu: null,
          subMenus: [
            {
              id: 1027, // Overzicht gesprekken (nieuwe gesprekkenmodule)
              icon: 'fas fa-comments',
              menu: null,
              default: true,
            },
          ]
        }
      ]
    },
    {
      role: UserLevelEnum.Employee, //Medewerker
      manager: false,
      delegate: false,
      menus: [
        {
          id: 169,
          icon: 'fas fa-envelope',
          menu: null
        },
        {
          id: 199, // Bibliotheekcatalogus
          icon: 'fas fa-file-image',
          menu: null,
        },
        {
          id: 962, // Job & Rolvereisten
          icon: 'fas fa-certificate',
          menu: null,
          subMenus: [
            {
              id: 185, // Kwalificatie overzicht
              icon: 'fas fa-certificate',
              menu: null,
              default: true,
            },
            {
              id: 289, // Skillsmatrix
              icon: 'fas fa-chart-line',
              menu: null,
            },
          ]
        },
        {
          id: 172, // R&S
          icon: 'fas fa-briefcase',
          menu: null
        },
        {
          id: 178, // Medewerkersontwikkeling
          icon: 'fas fa-graduation-cap',
          menu: null,
          subMenus: [
            {
              id: 181, // Aanvragen
              icon: 'fas fa-hourglass',
              menu: null,
            },
            {
              id: 180, // Huidige opleidingen
              icon: 'fas fa-calendar-alt',
              menu: null,
            },
            {
              id: 200, // Catalogus
              icon: 'fas fa-graduation-cap',
              menu: null,
              default: true,
            }
          ]
        },
        {
          id: 965, // Prestatiemanagement
          icon: 'fas fa-comments',
          menu: null,
          subMenus: [
            {
              id: 176, // Prestatiedoelstellingen
              icon: 'fas fa-bullseye',
              menu: null,
            },
            {
              id: 191, // Formele gesprekken
              icon: 'fas fa-calendar-alt',
              menu: null,
            },
            {
              id: 1017, // Overzicht gesprekken (nieuwe gesprekkenmodule)
              icon: 'fas fa-comments',
              menu: null,
              default: true,
            },
          ]
        }
      ]
    }
  ];

  private subscriptions: Subscription[] = [];

  constructor(
    private navigationService: NavigationService,
    private authService: AuthService,
    private companyService: CompanyService,
    private stylingService: CompanyStylingSettingsService,
    private modalService: NgbModal,
    private router: Router,
    private _userService: UserService,
    private elementRef: ElementRef,
    private homepageService: HomepageService
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
      this.companyService.get().subscribe(e => {
        this.companies = e.filter(c => c.id > 1);
      }),
      this.authService.getUserRoles(true).pipe(take(1)).subscribe((e) => {
        this.level = e.level;

        // LHR == CHR menu
        if (this.level == UserLevelEnum.LocalHr || this.level == UserLevelEnum.InterimHr) {
          this.level = UserLevelEnum.CorporateHr;
        }

        this.subscriptions.push(this.stylingService.getCompanyStylings().subscribe(e => {
          this.syncWithDefaultNavigation = e.sidebarWorksSynchronously;
          this.subscriptions.push(
            this.navigationService.fetchMenu().pipe(take(1)).subscribe(a => {
              this.home = a;

              this.menusWithIconsPerRole = this.menusWithIconsPerRole.filter(e => e.role == this.level);
              if (localStorage.getItem('manager_view') == '1') {
                this.menusWithIconsPerRole = this.menusWithIconsPerRole.filter(e => e.manager);
                if (localStorage.getItem('delegate_view') == '1') {
                  this.menusWithIconsPerRole = this.menusWithIconsPerRole.filter(e => e.delegate);
                } else {
                  this.menusWithIconsPerRole = this.menusWithIconsPerRole.filter(e => !e.delegate);
                }
              } else if (localStorage.getItem('delegate_view') == '1') {
                this.menusWithIconsPerRole = this.menusWithIconsPerRole.filter(e => e.delegate);
              } else {
                this.menusWithIconsPerRole = this.menusWithIconsPerRole.filter(e => !e.manager);
              }

              for (const role of this.menusWithIconsPerRole) {
                for (const menu of role.menus) {
                  menu.menu = this.findMenuItemRecursive(a, menu.id);
                  if (menu.menu) {
                    menu.moduleIds = menu.menu.crmModuleIds ? menu.menu.crmModuleIds.split(',').map(e => parseInt(e)) : [];
                  }

                  if (menu.subMenus && menu.subMenus.length) {
                    for (const subMenu of menu.subMenus) {
                      subMenu.menu = this.findMenuItemRecursive(a, subMenu.id);
                    }
                  }
                }
              }

              /**
               HR rollen: uitzondering voor klant zonder gesprekken en enkel met ad-hoc gesprekken
  
               Prestatiemanagement 734 vervangen door ad hoc gesprekken 750
              */
              // Prestatiemanagement 
              if (this.menusWithIconsPerRole[0].menus.filter(e => e.id == 734 && e.subMenus && e.subMenus.length).length) {
                let prestatieManagementMenu = this.menusWithIconsPerRole[0].menus.filter(e => e.id == 734)[0];

                if (prestatieManagementMenu.subMenus.filter(e => e.menu != null).length == 2) {
                  let activeSubmenus = prestatieManagementMenu.subMenus.filter(e => e.menu != null);

                  // ad hoc gesprekken en rapporten
                  if (activeSubmenus.filter(e => e.id == 750 || e.id == 738).length == 2) {
                    // test ok, enkel ad hoc staat aan 
                    let adhoc = activeSubmenus.filter(e => e.id == 750)[0];
                    prestatieManagementMenu.id = adhoc.id;
                    prestatieManagementMenu.icon = adhoc.icon;
                    prestatieManagementMenu.menu = adhoc.menu;
                    prestatieManagementMenu.subMenus = adhoc.subMenus;
                  }
                }
              }

              /**
               LG rol: uitzondering voor klant zonder gesprekken en enkel met ad-hoc gesprekken
  
               Prestatiemanagement 917 vervangen door ad hoc gesprekken 240
              */
              // Prestatiemanagement 
              if (this.menusWithIconsPerRole[0].menus.filter(e => e.id == 917 && e.subMenus && e.subMenus.length).length) {
                let prestatieManagementMenu = this.menusWithIconsPerRole[0].menus.filter(e => e.id == 917)[0];

                if (prestatieManagementMenu.subMenus.filter(e => e.menu != null).length == 1) {
                  let activeSubmenus = prestatieManagementMenu.subMenus.filter(e => e.menu != null);

                  // ad hoc gesprekken en rapporten
                  if (activeSubmenus.filter(e => e.id == 240).length == 1) {
                    // test ok, enkel ad hoc staat aan 
                    let adhoc = activeSubmenus.filter(e => e.id == 240)[0];
                    prestatieManagementMenu.id = adhoc.id;
                    prestatieManagementMenu.icon = adhoc.icon;
                    prestatieManagementMenu.menu = adhoc.menu;
                    prestatieManagementMenu.subMenus = adhoc.subMenus;
                  }
                }
              }

              /**
              MW rol: uitzondering voor klant zonder gesprekken en enkel met ad-hoc gesprekken
  
              Prestatiemanagement 965 vervangen door ad hoc gesprekken 192
             */
              // Prestatiemanagement 
              if (this.menusWithIconsPerRole[0].menus.filter(e => e.id == 965 && e.subMenus && e.subMenus.length).length) {
                let prestatieManagementMenu = this.menusWithIconsPerRole[0].menus.filter(e => e.id == 965)[0];

                if (prestatieManagementMenu.subMenus.filter(e => e.menu != null).length == 0) {
                  prestatieManagementMenu.id = 192;
                  prestatieManagementMenu.icon = 'fas fa-comment';
                  prestatieManagementMenu.menu = this.findMenuItemRecursive(a, 192);
                  prestatieManagementMenu.subMenus = null;
                }
              }

              this.visibleMenu = this.menusWithIconsPerRole[0].menus;
              this.setupNavigationEventListener();
            })
          );
        }))
      })
    );

    this.roles$ = this._userService.getUserRoles().pipe(
      tap((roles) => {
        if (roles && roles.level) {
          let role = this.Roles[roles.level];
          if (roles.isManager && localStorage.getItem('manager_view') === '1') {
            role = 'manager';
          }
          this.roleLabel = role;

          this.elementRef.nativeElement.style.setProperty('--progreso-role-nav-normal', this.getUserColor());
          this.elementRef.nativeElement.style.setProperty('--progreso-role-nav-active', this.getUserActiveColor());
        }
      })
    );

    this.subscriptions.push(
      this.homepageService.getWidgets().subscribe(e => {
        this.widgetTasks = e.find(w => w.angularComponent == 'HOME_TASKS') || new Widget();
        this.widgetRecruitment = e.find(w => w.angularComponent == 'HOME_RECRUITMENT') || new Widget();
        this.widgetGoals = e.find(w => w.angularComponent == 'HOME_GOALS') || new Widget();
        this.widgetDevelopment = e.find(w => w.angularComponent == 'HOME_DEVELOPMENT') || new Widget();
        this.widgetCertificates = e.find(w => w.angularComponent == 'HOME_COMPLIANCE') || new Widget();
        this.widgetSkills = e.find(w => w.angularComponent == 'HOME_MY_SKILLS') || new Widget();
        this.widgetConversations = e.find(w => w.angularComponent == 'HOME_CONVERSATIONS') || new Widget();

        for (const role of this.menusWithIconsPerRole) {
          for (const menu of role.menus) {
            if (menu.icon == 'fas fa-envelope') {
              menu.customIcon = this.widgetTasks.customIcon;
              menu.customCssIcon = this.widgetTasks.customCssIcon;
            }
            if (menu.icon == 'fas fa-briefcase') {
              menu.customIcon = this.widgetRecruitment.customIcon;
              menu.customCssIcon = this.widgetRecruitment.customCssIcon;
            }
            if (menu.icon == 'fas fa-bullseye') {
              menu.customIcon = this.widgetGoals.customIcon;
              menu.customCssIcon = this.widgetGoals.customCssIcon;
            }
            if (menu.icon == 'fas fa-graduation-cap') {
              menu.customIcon = this.widgetDevelopment.customIcon;
              menu.customCssIcon = this.widgetDevelopment.customCssIcon;
            }
            if (menu.icon == 'fas fa-certificate') {
              menu.customIcon = this.widgetCertificates.customIcon;
              menu.customCssIcon = this.widgetCertificates.customCssIcon;
            }
            if (menu.icon == 'fas fa-chart-line') {
              menu.customIcon = this.widgetSkills.customIcon;
              menu.customCssIcon = this.widgetSkills.customCssIcon;
            }
            if (menu.icon == 'fas fa-comments') {
              menu.customIcon = this.widgetConversations.customIcon;
              menu.customCssIcon = this.widgetConversations.customCssIcon;
            }

            if (menu.subMenus && menu.subMenus.length > 0) {
              for (const subMenu of menu.subMenus) {
                if (subMenu.icon == 'fas fa-envelope') {
                  subMenu.customIcon = this.widgetTasks.customIcon;
                  subMenu.customCssIcon = this.widgetTasks.customCssIcon;
                }
                if (subMenu.icon == 'fas fa-briefcase') {
                  subMenu.customIcon = this.widgetRecruitment.customIcon;
                  subMenu.customCssIcon = this.widgetRecruitment.customCssIcon;
                }
                if (subMenu.icon == 'fas fa-bullseye') {
                  subMenu.customIcon = this.widgetGoals.customIcon;
                  subMenu.customCssIcon = this.widgetGoals.customCssIcon;
                }
                if (subMenu.icon == 'fas fa-graduation-cap') {
                  subMenu.customIcon = this.widgetDevelopment.customIcon;
                  subMenu.customCssIcon = this.widgetDevelopment.customCssIcon;
                }
                if (subMenu.icon == 'fas fa-certificate') {
                  subMenu.customIcon = this.widgetCertificates.customIcon;
                  subMenu.customCssIcon = this.widgetCertificates.customCssIcon;
                }
                if (subMenu.icon == 'fas fa-chart-line') {
                  subMenu.customIcon = this.widgetSkills.customIcon;
                  subMenu.customCssIcon = this.widgetSkills.customCssIcon;
                }
                if (subMenu.icon == 'fas fa-comments') {
                  subMenu.customIcon = this.widgetConversations.customIcon;
                  subMenu.customCssIcon = this.widgetConversations.customCssIcon;
                }
              }
            }
          }
        }

        this.widgetsLoaded = true;
      })
    );

  }

  public clickMenuItem(menu?: SideNavMenuItem): void {
    let menuItem;

    if (!menu) {
      this.visibleMenu = this.menusWithIconsPerRole[0].menus;
      menuItem = this.home;

    } else {
      if (menu.subMenus && menu.subMenus.length) {

        if (menu.subMenus.filter(e => e.default).length) {
          menuItem = menu.subMenus.filter(e => e.default)[0].menu;

          if (!menuItem) {
            if (menu.subMenus.filter(e => e.menu).length) {
              menuItem = menu.subMenus.filter(e => e.menu)[0].menu;
              this.visibleMenu = menu.subMenus;
            }
            else {
              menuItem = menu.menu;
            }
          } else {
            this.visibleMenu = menu.subMenus;
          }
        }
        else {
          menuItem = menu.subMenus[0].menu;
          this.visibleMenu = menu.subMenus;
        }
      } else {
        menuItem = menu.menu;
      }
    }

    if (menuItem && menuItem.getAngularUrl() && (menuItem.id != 697 && menuItem.id != 698 && menuItem.id != 699 && menuItem.id != 700)) {
      this.navigateToUrl(menuItem.getAngularUrl(), menuItem);
    }

    if (menuItem && (menuItem.id == 697 || menuItem.id == 698 || menuItem.id == 699 || menuItem.id == 700)) {
      let parameters = {};
      let url = 'chr/company';
      switch (menuItem.id) {
        case 697: url = 'chr/companydepartments';
          break;
        case 698:
        case 699: url = 'chr/companypositions';
          break;
        case 700: url = 'chr/companyfunctions';
          break;
      }

      if (this.companies.length == 1) {
        parameters['item'] = this.companies[0].id;
        this.navigateToUrl(url, menuItem, parameters);
      } else {
        let modal = this.modalService.open(this.modalcontent, { centered: false, backdrop: true, size: 'sm' });
        modal.result.then((a) => {
          parameters['item'] = a;
          this.navigateToUrl(url, menuItem, parameters);
        }, () => { })
      }
    }
  }

  public getUserColor() {
    switch (this.roleLabel) {
      case 'Employee': return 'var(--progreso-accent)';
      case 'manager': return 'var(--progreso-accent-hover)';
      case 'Trainer': return 'var(--progreso-primary)';
      case 'LocalHr': return 'var(--progreso-secondary)';
      case 'CorporateHr': return 'var(--progreso-secondary)';
      default: return '#000';
    }
  }

  public getUserActiveColor() {
    switch (this.roleLabel) {
      case 'Employee': return 'var(--progreso-primary)';
      case 'manager': return 'var(--progreso-primary)';
      case 'Trainer': return 'var(--progreso-accent)';
      case 'LocalHr': return 'var(--progreso-primary)';
      case 'CorporateHr': return 'var(--progreso-primary)';
      default: return '#000';
    }
  }

  ngOnDestroy(): void {
    for (const subscr of this.subscriptions) {
      subscr.unsubscribe();
    }
  }

  private findMenuItemRecursive(item: MenuItem, menuIdToFind: number): MenuItem {
    if (item.id == menuIdToFind && !item.hideInNavigation) {
      return item;
    } else {
      for (let i = 0; i < item.subPages.length; i += 1) {
        let result = this.findMenuItemRecursive(item.subPages[i], menuIdToFind);
        if (result != null)
          return result;
      }
    }
    return null;
  }

  private navigateToUrl(url: string, menuItem: MenuItem, extraQueryParams?) {
    this.router.navigate([url], { queryParams: { menuItem: menuItem.id, ...extraQueryParams }, queryParamsHandling: 'merge' });
  }

  private setupNavigationEventListener(): void {
    this.subscriptions.push(
      this.router.events
        .pipe(
          filter((event: Event) => event instanceof NavigationEnd),
          tap((event: Event) => {
            let url = (event as NavigationEnd).url;
            let param = getParameterByName('menuItem', url);
            const formattedUrl = this.formatUrl(url);
            const activeMenuItem = this.containsUrl(
              formattedUrl,
              this.home,
              (!param ? null : parseInt(param))
            );

            if (this.syncWithDefaultNavigation && activeMenuItem && activeMenuItem.getAngularUrl()) {
              let found = false;
              for (let menuItem of this.menusWithIconsPerRole[0].menus) {
                if (menuItem.menu && !menuItem.menu.hideInNavigation && (!menuItem.subMenus || !menuItem.subMenus.filter(e => e.menu && !e.menu.hideInNavigation).length) && menuItem.menu.getAngularUrl() == activeMenuItem.getAngularUrl()) {
                  this.visibleMenu = this.menusWithIconsPerRole[0].menus;
                  found = true;
                  break;
                }

                if (menuItem.subMenus) {
                  for (const subMenuItem of menuItem.subMenus) {
                    if (subMenuItem.menu && !subMenuItem.menu.hideInNavigation && subMenuItem.menu.getAngularUrl() == activeMenuItem.getAngularUrl()) {
                      this.visibleMenu = menuItem.subMenus;
                      found = true;
                      break;
                    }
                  }
                }
              }

              if (!found && activeMenuItem.crmModuleIds && activeMenuItem.crmModuleIds != '2') {
                for (let menuItem of this.menusWithIconsPerRole[0].menus.filter(e => e.id != 525 && e.subMenus && e.subMenus.length && e.moduleIds && e.moduleIds.length)) {
                  for (const moduleId of menuItem.moduleIds) {
                    if (activeMenuItem.crmModuleIds.split(',').filter(e => e == moduleId.toString()).length) {
                      this.visibleMenu = menuItem.subMenus;
                      found = true;
                      break;
                    }
                  }
                }
              }

              if (!found && activeMenuItem.crmModuleIds && activeMenuItem.crmModuleIds == '2' && !this.isSettingsPage(activeMenuItem)) {
                let menuItem = this.menusWithIconsPerRole[0].menus.filter(e => e.id == 696)[0];
                if (menuItem) {
                  this.visibleMenu = menuItem.subMenus;
                  found = true;
                }
              }

              if (!found) {
                this.visibleMenu = this.menusWithIconsPerRole[0].menus;
              }
            }

            for (const submenuItem of this.visibleMenu) {
              if (activeMenuItem && submenuItem && submenuItem.menu && submenuItem.menu.getAngularUrl() == activeMenuItem.getAngularUrl()) {
                submenuItem.active = true;
              } else {
                submenuItem.active = false;
              }
            }

            this.homeActive = activeMenuItem && this.home && activeMenuItem.getAngularUrl() == this.home.getAngularUrl();

            if (this.homeActive) {
              this.visibleMenu = this.menusWithIconsPerRole[0].menus;
            }
          })
        )
        .subscribe()
    );
  }

  private isSettingsPage(menuItem: MenuItem): boolean {
    if (menuItem.id == 525) {
      return true;
    } else {
      if (menuItem.parent) {
        return this.isSettingsPage(menuItem.parent);
      }
    }

    return false;
  }

  private formatUrl(url: string): string {
    let formattedUrl = url.replace('/', '');
    if (formattedUrl.indexOf('?') > -1) {
      formattedUrl = formattedUrl.slice(0, formattedUrl.indexOf('?'));
    }

    const parts = formattedUrl.split('/');
    if (new RegExp(/^\d+$/).test(parts[parts.length - 1])) {
      parts.pop();
      parts.push(':id');
      formattedUrl = parts.join('/');
    }

    return formattedUrl;
  }

  private containsUrl(formattedUrl: string, menuItem: MenuItem, menuItemId?: number, menuItemInParent = false): MenuItem {
    if (!menuItem) {
      return null;
    }

    const itemFormattedUrl = menuItem.url.substring(1);

    if (menuItem && (formattedUrl === itemFormattedUrl || formattedUrl.replace("/:id", "") === itemFormattedUrl) && (!menuItemId || menuItemId == menuItem.id || menuItemInParent)) {
      menuItem.isActive = true;
      return menuItem;
    }

    for (let i = 0; menuItem.subPages && i < menuItem.subPages.length; i++) {
      const subItem: MenuItem = menuItem.subPages[i];

      if (!subItem) {
        continue;
      }

      menuItemInParent = !!menuItemId && (menuItemInParent || menuItem.id == menuItemId);
      const activeMenuItem = this.containsUrl(formattedUrl, subItem, menuItemId, menuItemInParent);
      if (activeMenuItem != null) {
        menuItem.subPages[i].hasActiveTrail = true;
        menuItem.hasActiveTrail = true;
        return activeMenuItem;
      }
    }
    return null;
  }
}

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


export class SideNavMenuWrapper {
  role: UserLevelEnum;
  manager?: boolean;
  delegate?: boolean;
  menus: SideNavMenuItem[];
}

export class SideNavMenuItem {
  id: number;
  icon: string;
  customIcon?: string;
  customCssIcon?: string;
  menu: MenuItem;
  subMenus?: SideNavMenuItem[];
  default?: boolean;
  active?: boolean;
  moduleIds?: number[];
}
